import React, { FC } from 'react'
import { getTopTilesItems } from '../selectors'
import { useSelector } from 'react-redux'
import styles from './Homepage.module.scss'
import TileList from 'components/SA/Fallback/Tiles/TilesList'
import useQA from 'hooks/useQA'

const TopTiles: FC = () => {
  const { testId } = useQA()
  const topTilesItems = useSelector(getTopTilesItems)

  const TILES_DATA = topTilesItems.map((item) => {
    const { jpgLarge, linkText, linkUrl, title } = item
    return {
      imageUrl: jpgLarge,
      name: title,
      url: linkUrl,
      linkTitle: linkText,
    }
  })

  return (
    <div className={styles.topTilesContainer} {...testId('top-tiles-container')}>
      <TileList tiles={TILES_DATA} />
    </div>
  )
}

export default TopTiles
